export const COMPLETED = 'COMPLETED';
export const LOADING = 'LOADING';
export const UNINITIALIZED = 'UNINITIALIZED';
export const ERROR = 'ERROR';
export const BROKER_PRODUCTS = 'BROKER_PRODUCTS';
export const BROKER_PRODUCT = 'BROKER_PRODUCT';
